import SEMRushWebsiteTrafficController from '../controllers/SEMRushWebsiteTrafficController';
import commonHandler from '../errorHandlers/common-handler';
import { getActionHookBuilder } from './action-hook-builder';

const SEMRushWebsiteTrafficActions = {
  retriveTotalsByDomain(domain: string, ipAdress?: number) {
    return async dispatch => {
      try {
        return await SEMRushWebsiteTrafficController.getTotalsByDomain(
          domain,
          ipAdress,
        );
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  },

  retriveMonthlyByDomain(domain: string, ipAdress?: number) {
    return async dispatch => {
      try {
        return await SEMRushWebsiteTrafficController.getMonthlyByDomain(
          domain,
          ipAdress,
        );
      } catch (error) {
        return commonHandler(dispatch)(error);
      }
    };
  },
};

export const useSEMRushWebsiteTrafficCRUDActions = getActionHookBuilder(
  SEMRushWebsiteTrafficActions,
  ['retriveTotalsByDomain', 'retriveMonthlyByDomain'],
);
